import React from 'react';

import { useTranslation } from 'react-i18next';

import { UiDropdownSearchList } from '@shared/ui';

import type { MoveWarehouseListItem } from '../model/types';

interface MoveWarehouseDropdownContentProps {
    warehouses: MoveWarehouseListItem[];
    onClose: () => void;
    onWarehouseClick?: (warehouse: MoveWarehouseListItem) => void;
}

export const MoveWarehouseDropdownContent = ({
    warehouses,
    onClose,
    onWarehouseClick,
}: MoveWarehouseDropdownContentProps) => {
    const { t } = useTranslation();

    return (
        <UiDropdownSearchList
            title={t('EditWarehouseModal.return.SearchModal.titleText')}
            items={warehouses}
            onClose={onClose}
            onItemClick={onWarehouseClick}
        />
    );
};
